var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-header',[_c('el-button',{on:{"click":_vm.newSearch}},[_vm._v("New Search")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.goToRandomPokemon}},[_vm._v("Random")])],1),_vm._v(" "),_c('el-main',[_vm._t("default")],2),_vm._v(" "),_c('el-footer',[_vm._v("EmilyRosina © "+_vm._s(new Date().getFullYear()))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f74eb692","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/Results.vue
// module id = null
// module chunks = 